import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const AdminLoginPage = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@mzstore.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Invalid credentials";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="eyebrow mb-2">Restricted</div>
          <h1 className="font-serif text-4xl text-ink">Admin Sign-in</h1>
        </div>
        <form onSubmit={onSubmit} className="space-y-5 bg-white border border-gold-soft p-8">
          <div>
            <label className="eyebrow block mb-2 text-ash">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 px-4 border border-gold-soft bg-cream text-ink focus:outline-none focus:border-gold transition"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2 text-ash">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-12 px-4 border border-gold-soft bg-cream text-ink focus:outline-none focus:border-gold transition"
            />
          </div>
          {error && (
            <div data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-ink text-cream h-12 text-xs uppercase tracking-[0.22em] font-medium hover:bg-gold transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
